package pwgs.ui.scenes.ensureloggedin

import kotlinx.browser.window
import org.w3c.dom.url.URLSearchParams
import pwgs.ui.scenes.acceptinvitationscene.AcceptInvitationScene
import pwgs.ui.scenes.acceptinvitationscene.AcceptInvitationSceneProps
import pwgs.ui.scenes.login.LoginScene
import pwgs.ui.scenes.login.LoginSceneProps
import pwgs.ui.scenes.logoutscene.LogoutScene
import pwgs.ui.scenes.logoutscene.LogoutSceneProps
import pwgs.ui.scenes.projectlist.ProjectListScene
import pwgs.ui.scenes.projectlist.ProjectListSceneProps
import pwgs.ui.scenes.projectrootscene.ProjectRootScene
import pwgs.ui.scenes.projectrootscene.ProjectRootSceneProps
import visage.core.*

class MEnsureLoggedInScene(props: EnsureLoggedInSceneProps) : AScene<EnsureLoggedInSceneProps, EnsureLoggedInSceneModel, EnsureLoggedInSceneState, EnsureLoggedInControllerFe>(props) {

    override fun createController() : EnsureLoggedInControllerFe {
        return EnsureLoggedInControllerFe(props, this)
    }

    override fun initState() : EnsureLoggedInSceneState {
        return EnsureLoggedInSceneState()
    }

    override fun Components.render(children: List<AComponent<*>>) {
        if (this@MEnsureLoggedInScene.model.isLoading) {
            +"Loading..."
        }
        else {
            if (this@MEnsureLoggedInScene.model.isLoggedIn) {
                Router {
                    route("/app/logout.vsg") {
                        LogoutScene(LogoutSceneProps())
                    }
                    route("/app/index.vsg") {
                        ProjectListScene(ProjectListSceneProps())
                    }
                    route("/app/project/{projectId}/*") {
                        val projectId = params["projectId"]!!.toLong()
                        ProjectRootScene(ProjectRootSceneProps(projectId))
                    }
                    route("/app/acceptInvitation.vsg") {
                        var p = URLSearchParams(window.location.search)
                        AcceptInvitationScene(AcceptInvitationSceneProps(p.get("id")!!))
                    }
                }
            } else {
                LoginScene(LoginSceneProps())
            }
        }
    }
}

class EnsureLoggedInSceneState {

}

fun Components.EnsureLoggedInScene(props: EnsureLoggedInSceneProps) = this.registerComponent(MEnsureLoggedInScene(props), {})
